// Filtros combinados de drill-down del dashboard "INDICADORES": al hacer click en un elemento de una
// gráfica/tabla (sede, vendedor, producto, línea, tipo de auto, marca, cliente) se AGREGA un filtro.
// Los filtros se combinan con AND, uno por tipo: un click en otra marca REEMPLAZA la marca anterior y
// deja los demás. Los KPIs no responden a estos filtros — solo las gráficas filtrables (ver
// DashboardSaleIndicatorsService::FILTERABLE_CHARTS en el backend).

// Texto del prefijo de cada badge verde ("Sede: BATERICARS 06"). Las claves son las mismas que
// DashboardSaleIndicatorsService::DRILL_DOWN_FILTER_FIELDS en el backend.
export const FILTER_LABELS = {
    branchoffice: 'Sede',
    seller: 'Vendedor',
    product: 'Prod',
    line: 'Linea',
    vehicle_type: 'Tipo Auto',
    brand: 'Marca',
    customer: 'Cliente'
}

// Filtros activos [{type, id, label}] -> texto JSON {tipo: id} con las claves ORDENADAS, para el
// parámetro "filters" del endpoint. Se manda como string JSON (no como objeto anidado: axios 0.x
// serializa raro los objetos anidados en query string) y, al estar ordenado, la misma combinación
// siempre da el mismo texto — que también sirve de llave del cache de respuestas (ver actions.js).
export function filtersParam(filters) {
    const params = {}

    filters.slice()
        .sort((a, b) => (a.type < b.type ? -1 : a.type > b.type ? 1 : 0))
        .forEach(filter => { params[filter.type] = filter.id })

    return JSON.stringify(params)
}



// WEBPACK FOOTER //
// ./src/components/dashboard-sale-indicators/filters.js